import React, {ReactNode, useEffect, useState} from 'react';
import {loadRuntimeConfig, RuntimeConfig} from '../services/runtimeConfig';
import {ConfigProvider} from '../contexts/ConfigContext';

interface ConfigLoaderProps {
  children: ReactNode;
}

const ConfigLoader: React.FC<ConfigLoaderProps> = ({children}) => {
  const [config, setConfig] = useState<RuntimeConfig | null>(null);

  const loadUmamiScript = (config: RuntimeConfig) => {
    if (document.getElementById('umami-script')) {
      return;
    }
    if (!config.UMAMI_WEBSITE_ID) {
      console.error('Umami is not configured, skipping script load');
      return;
    }

    const script = document.createElement('script');
    script.id = 'umami-script';
    script.defer = true;
    script.src = config.UMAMI_URL + '/script.js';
    script.setAttribute('data-website-id', config.UMAMI_WEBSITE_ID);

    document.head.appendChild(script);
  }

  useEffect(() => {
    loadRuntimeConfig()
      .then(loadedConfig => {
        setConfig(loadedConfig);
        loadUmamiScript(loadedConfig);
      })
      .catch(err => {
        console.error('Failed to load runtime configuration', err);
      });
  }, []);

  if (!config) {
    return null;
  }

  return (
    <ConfigProvider config={config}>
      {children}
    </ConfigProvider>
  );
};

export default ConfigLoader;

